import React, { useRef } from "react";
import html2pdf from "html2pdf.js";

const CommonPostSellLetter = () => {
  const letterRef = useRef();

  // Static agreement number for testing
  const agreementNo = "ckVLH00000074";

  const getPdfOptions = () => ({
    margin: [0, 0, 0, 0],
    filename: `Pre_Sale_Notice_${agreementNo}.pdf`,
    image: { type: "jpeg", quality: 0.98 },
    html2canvas: { scale: 2, useCORS: true, letterRendering: true },
    jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
    pagebreak: { mode: ["css", "legacy"] },
  });

  const handleDownloadPdf = () => {
    html2pdf().set(getPdfOptions()).from(letterRef.current).save();
  };

  const handlePreview = () => {
    html2pdf().set(getPdfOptions()).from(letterRef.current).outputPdf("bloburl")
      .then((url) => window.open(url, "_blank"));
  };

  const handlePrint = () => {
    html2pdf().set(getPdfOptions()).from(letterRef.current).toPdf().get("pdf")
      .then((pdf) => {
        pdf.autoPrint();
        window.open(pdf.output("bloburl"), "_blank");
      });
  };

  const page = {
    width: "794px",
    backgroundColor: "#fff",
    boxSizing: "border-box",
    padding: "50px 55px",
    fontFamily: "'Times New Roman', Times, serif",
    fontSize: "13px",
    color: "#000",
    lineHeight: "1.5",
    border: "1px solid #ccc",
    margin: "0 auto",
  };

  const editableStyle = {
    outline: "none",
    border: "1px dashed transparent",
    transition: "border 0.2s",
  };

  const EditableDiv = ({ children, style, ...props }) => (
    <div
      contentEditable
      suppressContentEditableWarning
      style={{ ...editableStyle, ...style }}
      onFocus={(e) => {
        e.target.style.border = "1px dashed #00b8d4";
      }}
      onBlur={(e) => {
        e.target.style.border = "1px dashed transparent";
      }}
      {...props}
    >
      {children}
    </div>
  );

  const Header = () => (
    <div style={{ textAlign: "center", marginBottom: "18px" }} contentEditable={false}>
      {/* Logo ko strictly center karne ke liye display: block aur margin: auto lagaya gaya hai */}
      <img
        src="/assets/ckern-logo.png"
        alt="cKers Finance"
        style={{ height: "60px", display: "block", margin: "0 auto 4px auto" }}
        onError={(e) => { e.target.style.display = "none"; }}
      />
      <div style={{ fontWeight: "bold", fontSize: "15px", color: "#1F3864", marginTop: "2px" }}>
        cKers Finance Private Limited
      </div>
      <div style={{ fontSize: "10.5px", color: "#C0531A", fontWeight: "bold" }}>
        Building No. 24-30, First Floor, Okhla Industrial Estate, Phase III, New Delhi-110020
      </div>
      <div style={{ fontSize: "10.5px", color: "#C0531A", fontWeight: "bold" }}>
        CIN: U65910DL2016PTC291909, Ph. No: 011-41070629, Email:{" "}
        <span style={{ textDecoration: "underline", color: "#0563C1" }}>contact@ckersfinance.in</span>
      </div>
    </div>
  );

  // Static Data
  const d = {
    ref_no: "CKERS/2026/001",
    date: "19-06-2026",
    name: "Test Applicant",
    full_address: "123, Gurgaon, Haryana",
    mobile: "9876543210",
    agreement_no: "ckVLH00000074",
    total_due: "1,25,000",
    model: "TATA ACE",
    vehicle_no: "DL51GD3855",
    contact_person_name: "Samander",
    contact_person_phone: "+918448832423",
  };

  const coApplicants = [
    { name: "TEST CO APPLICANT", full_address: "Delhi", mobile: "9999999999" },
  ];

  const guarantors = [
    { name: "TEST GUARANTOR", full_address: "Noida", mobile: "8888888888" },
  ];

  return (
    <div style={{ backgroundColor: "#e9ecef", minHeight: "100vh", fontFamily: "Arial, sans-serif" }}>
      {/* Buttons & Info Header */}
      <div style={{ display: "flex", justifyContent: "center", gap: "15px", padding: "15px 40px", backgroundColor: "#fff", borderBottom: "1px solid #ddd", position: "sticky", top: 0, zIndex: 10, boxShadow: "0 2px 10px rgba(0,0,0,0.05)" }}>
        <div style={{ color: "#000000", fontWeight: "bold", marginRight: "auto", display: "flex", alignItems: "center" }}>
          Generate Pre-Sell Letter
        </div>
        <button onClick={handlePreview} style={{ backgroundColor: "#00b8d4", color: "#fff", border: "none", padding: "10px 8px", borderRadius: "6px", fontSize: "12px", fontWeight: "600", cursor: "pointer", boxShadow: "0 2px 4px rgba(0,0,0,0.1)" }}>PREVIEW</button>
        <button onClick={handleDownloadPdf} style={{ backgroundColor: "#ffb300", color: "#fff", border: "none", padding: "10px 8px", borderRadius: "6px", fontSize: "12px", fontWeight: "600", cursor: "pointer", boxShadow: "0 2px 4px rgba(0,0,0,0.1)" }}>DOWNLOAD PDF</button>
      </div>

      <div style={{ display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center", padding: "40px 0", gap: "20px" }}>
        
        <div ref={letterRef} style={{ display: "flex", flexDirection: "column", gap: "20px" }}>

          {/* PAGE 1 */}
          <div style={{ ...page, pageBreakAfter: "always" }} className="html2pdf__page-break">
            <Header />

            <EditableDiv style={{ textAlign: "center", marginBottom: "14px" }}>
              <span style={{ textDecoration: "underline", fontWeight: "bold", fontSize: "13px" }}>Speed Post</span>
            </EditableDiv>

            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "14px", fontSize: "12.5px" }}>
              <EditableDiv>{d.ref_no}</EditableDiv>
              <EditableDiv>DATE: {d.date}</EditableDiv>
            </div>

            <div style={{ display: "flex", marginBottom: "10px" }}>
              <div style={{ width: "95px", fontWeight: "bold", flexShrink: 0 }}>Applicant :</div>
              <EditableDiv>
                <div style={{ fontWeight: "bold" }}>Mr./Ms. {d.name}</div>
                <div>{d.full_address}</div>
                <div>{d.mobile}</div>
              </EditableDiv>
            </div>

            {coApplicants.map((ca, i) => (
              <div key={i} style={{ display: "flex", marginBottom: "10px" }}>
                <div style={{ width: "95px", fontWeight: "bold", flexShrink: 0 }}>Co-Applicant :</div>
                <EditableDiv>
                  <div style={{ fontWeight: "bold" }}>Ms./Mr. {ca.name}</div>
                  <div>{ca.full_address}</div>
                  <div>{ca.mobile}</div>
                </EditableDiv>
              </div>
            ))}

            {guarantors.map((g, i) => (
              <div key={i} style={{ display: "flex", marginBottom: "14px" }}>
                <div style={{ width: "95px", fontWeight: "bold", flexShrink: 0 }}>Guarantor :</div>
                <EditableDiv>
                  <div style={{ fontWeight: "bold" }}>Mr./Ms. {g.name}</div>
                  <div>{g.full_address}</div>
                  <div>{g.mobile}</div>
                </EditableDiv>
              </div>
            ))}

            <EditableDiv style={{ textAlign: "center", marginBottom: "14px", marginTop: "20px" }}>
              <div style={{ textDecoration: "underline", fontWeight: "bold", fontSize: "13px" }}>
                PRE SALE NOTICE FOR PAYMENT OF DUES AMOUNT IN RESPECT OF
              </div>
              <div style={{ textDecoration: "underline", fontWeight: "bold", fontSize: "13px" }}>
                LOAN AGREEMENT NO. {d.agreement_no}
              </div>
            </EditableDiv>

            <EditableDiv style={{ marginBottom: "10px" }}>Dear Sir,</EditableDiv>

            <EditableDiv style={{ textAlign: "justify", marginBottom: "10px" }}>
              On the basis of the representations of being financially sound and having capacity to repay the loan amount, we had granted a loan facility upon terms and conditions more particularly mentioned in the above said loan <b>Agreement</b> to the you the above noted addresses and in discharge of the financial liabilities arising there from and you all had undertaken and agreed to repay the same in installments.
            </EditableDiv>

            <EditableDiv style={{ textAlign: "justify" }}>
              We hereby state that, the addressee failed to discharge his financial responsibilities and you stood as Applicant / Guarantor /Co-Borrower for the addressee. Hence you all the addressees are liable to discharge the financial obligation under the loan agreement number mentioned here in above and you all are equally liable to discharge the financial obligation and have started defaulting in making payment of the said installments and other contractual charges payable to our client under the said agreement and. We have presented several post dated cheques/ECS, issued by you addressees in favour of cKers Finance Private Limited towards repayment of the said loan , which were returned unpaid from your bankers and we had to incur Cheque dishonor charges. As of date <b>various installments</b> have become due against you which you all have not bothered to pay. We want to states that as a result of yours' delaying in the payment of the said amount despite follow-ups, the total foreclosure amount due and payable from your account has, together with interest, accumulated to the tune of <b>Rs. {d.total_due}/-</b> as on <b>{d.date}.</b>
            </EditableDiv>
          </div>

          {/* PAGE 2 */}
          <div style={page}>
            <Header />

            <EditableDiv style={{ textAlign: "justify", marginBottom: "14px" }}>
              That in terms of the agreement the hypothecated vehicle make <b>{d.model}</b> Deliver Number <b>{d.vehicle_no}</b> has been taken in to possession from you the addressee.
            </EditableDiv>

            <EditableDiv style={{ textAlign: "justify", marginBottom: "14px" }}>
              Hence, we therefore, instructs us to call upon you, which we hereby do to, pay to us a sum of <b>Rs. {d.total_due}/-</b> within 7 days from receipt of this notice, and get your vehicle released from our client, failing which, we shall have rights to sell the aforesaid vehicle to realised said amount.
            </EditableDiv>

            <EditableDiv style={{ textAlign: "justify", marginBottom: "14px" }}>
              We, however, hopes that good counsel will prevail on all of you and you will comply with the requisitions contained in this notice within the said period and will not force us to initiate coercive actions as stated herein above.
            </EditableDiv>

            <EditableDiv style={{ marginBottom: "40px" }}>
              if any clarification call the Mr {d.contact_person_name || "Samander"} on said {d.contact_person_phone || "+918448832423"}.
            </EditableDiv>

            <div style={{ marginTop: "60px" }}>
              <EditableDiv style={{ fontWeight: "bold", marginBottom: "60px", width: "max-content" }}>
                For cKers Finance Private Limited
              </EditableDiv>
              <EditableDiv style={{ fontWeight: "bold", width: "max-content" }}>
                (Authorized Signatory)
              </EditableDiv>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default CommonPostSellLetter;